import type { UserProfile, UserProfileRead } from "epsm-api-types/models";
import type { AuthContextType } from "@/context/AuthContext";
import ErrorHandler from "@/services/ErrorService/ErrorService";
import { HttpClient } from "@/services/HttpClient";
import type {
	FormType,
	StripeUpdateData,
	SubscriptionPeriod,
	SubscriptionPlan,
} from "../../types";

type Args = {
	plan: SubscriptionPlan | null;
	period: SubscriptionPeriod;
	context: AuthContextType | null;
	setOpenModal: (modal: FormType) => void;
	updatePlan: (options: StripeUpdateData) => Promise<unknown | null>;
	cancelPlan: () => Promise<unknown | null>;
	userData: Partial<UserProfile & UserProfileRead> | null;
	setSubscriptionWillCancel: (value: boolean) => void;
};
export async function updateSubscription(args: Args) {
	const {
		plan,
		period,
		context,
		updatePlan,
		cancelPlan,
		setOpenModal,
		userData,
		setSubscriptionWillCancel,
	} = args;

	if (!context?.isAuthenticated || !plan) return;

	try {
		if (plan === "bronze") {
			await cancelPlan();
		} else {
			await updatePlan({
				plan,
				period,
			});
		}

		const res = await HttpClient.refreshAccessToken();
		const newRoles = context.getRolesFromToken(res.access_token);
		context.updateUserRoles(newRoles);

		if (userData) {
			userData.subscriptionInterval = period;
			setSubscriptionWillCancel(plan === "bronze");
		}

		setOpenModal("success");
	} catch (error) {
		ErrorHandler.logError(error as Error);
		return error as Error;
	}
}

export type UpdateSubscriptionFn = typeof updateSubscription;
